import { connect } from 'react-redux';
import { getLocations, getLocationsByType, getBuildings, getPointOfInterestTypes, resetPage, resetMeta, getPointOfInterests } from '../../actions/MapPage';
import { getBuildingFloorGeojson, getBuildingFloorNavNodes } from '../../actions/LocationDetailPage';
import MapPage from './MapPage';

const mapsStateToProps = state => ({ 
	pageProps: state.mapPageReducer,
	locationPageProps: state.locationDetailPage.locationDetailPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPointOfInterestTypes(options) {
		dispatch(getPointOfInterestTypes(options));
	},
	getBuildingFloorGeojson(options) {
		dispatch(getBuildingFloorGeojson(options));
	},
	getBuildingFloorNavNodes(options) {
		dispatch(getBuildingFloorNavNodes(options));
	},
	getPointOfInterests(options) {
		dispatch(getPointOfInterests(options));
	},
	getBuildings(options) {
		dispatch(getBuildings(options));
	},
	getLocations(options) {
		dispatch(getLocations(options));
	},
	getLocationsByType(options) {
		dispatch(getLocationsByType(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(MapPage);